/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';

/**
 * 
 * @export
 * @interface GamerTag
 */
export interface GamerTag {
    /**
     * 
     * @type {string}
     * @memberof GamerTag
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GamerTag
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof GamerTag
     */
    platformUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof GamerTag
     */
    name: string;
    /**
     * 
     * @type {DataSource}
     * @memberof GamerTag
     */
    source: DataSource;
    /**
     * 
     * @type {number}
     * @memberof GamerTag
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the GamerTag interface.
 */
export function instanceOfGamerTag(value: object): value is GamerTag {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GamerTagFromJSON(json: any): GamerTag {
    return GamerTagFromJSONTyped(json, false);
}

export function GamerTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamerTag {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'platformUserId': json['platformUserId'] == null ? undefined : json['platformUserId'],
        'name': json['name'],
        'source': DataSourceFromJSON(json['source']),
        'updatedAt': json['updatedAt'],
    };
}

export function GamerTagToJSON(json: any): GamerTag {
    return GamerTagToJSONTyped(json, false);
}

export function GamerTagToJSONTyped(value?: GamerTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'gameId': value['gameId'],
        'platformUserId': value['platformUserId'],
        'name': value['name'],
        'source': DataSourceToJSON(value['source']),
        'updatedAt': value['updatedAt'],
    };
}

